import { findNearLink } from "@/shared/utils/reader/reader";
import { Hotkey, isEventKey, KeyCode } from "@/shared/utils/dom";
import { useHotKey } from "@/shared/hooks/useKeyboard";

const useReaderLinksNavigation = ({
  idPara,
  linkActive,
  indexPanel,
  onNewLink,
  isOpenFirstIfNoLinkActive,
}) => {
  // Implement to {linkFocused} instead, if problems with the immediate link opening.
  const handleHotKeyReaderLink = async (event) => {
    const newLink = findNearLink(
      isEventKey(event, KeyCode.rightArrow),
      linkActive,
      idPara,
      indexPanel,
      isOpenFirstIfNoLinkActive,
    );

    if (newLink) {
      onNewLink(newLink);
    }
  };

  useHotKey(Hotkey.readerLinkPrev.keyCode, handleHotKeyReaderLink);
  useHotKey(Hotkey.readerLinkNext.keyCode, handleHotKeyReaderLink);
};

export default useReaderLinksNavigation;
